import { render, staticRenderFns } from "./CardsWaterScanWaterFix.vue?vue&type=template&id=60df874d&"
import script from "./CardsWaterScanWaterFix.vue?vue&type=script&lang=js&"
export * from "./CardsWaterScanWaterFix.vue?vue&type=script&lang=js&"
import style0 from "./CardsWaterScanWaterFix.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VHover,VIcon,VListItem,VListItemContent})
